import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useCartContext } from '../../context/CartContext';
import { useGlobalContext } from '../../context/GlobalContext';
import Step1 from './Step1/Step1';
import Step2 from './Step2/Step2';
import TopSection from './TopSection/TopSection';
import PromoBanner from '../../components/common/PromoBanner';

const HomePage = () => {
  const { store, loading, step, goToStep, currentLanguage, selectedStore,setCurrentStore,
    defaultLanguage } = useGlobalContext();
  const { selectedStoreCards, calcCartTotals, cart } = useCartContext();
  const { store: storeParam } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (store && store.cards) {
      if (!storeParam || (storeParam !== 'digital' && storeParam !== 'physical')) {
        if (store.physical_store && !selectedStore) {
          navigate('/stores');
          return;
        } else {
          setCurrentStore('digital');
        }
      } else {
        setCurrentStore(storeParam);
      }
      calcCartTotals(store);
    }
  }, [store, storeParam, navigate, calcCartTotals]);

  if (loading || !store || Object.keys(store).length === 0) {
    return (
      <div id="preloader">
        <div id="loader"></div>
      </div>
    );
  }

  const currentLangCode = currentLanguage?.code || defaultLanguage;
  const hasErrors = store.isAvailable === false || (store.errors && store.errors.length > 0);
  return (
    <div id="homePage" className={`step-${step}`} role="region" aria-label={t("Page d'accueil")}>
      {!hasErrors && !loading && (

        <TopSection
          step={step}
          store={store}
          lang={currentLangCode}
          selectedStore={selectedStore}
        />
      )}
      {!hasErrors && !loading && step === 1 && (
        <PromoBanner store={store} lang={currentLangCode} />
      )}
      <div className={`mainContent step-${step}`}>
        {!hasErrors ? (
          <div className="wrapper">
            {step === 1 && (
              <Step1
                step={step}
                store={store}
                selectedStore={selectedStore}
                lang={currentLangCode}
                cart={cart}
                onStepChange={goToStep}
                selectedStoreCards={selectedStoreCards}
                sendCard={() => {
                  goToStep(2);
                }}
              />
            )}
            {(step === 2 || step === 'payment') && (
              <Step2
                step={step}
                store={store}
                onStepChange={goToStep}
                selectedStore={selectedStore}
                lang={currentLangCode}
                cart={cart}
              />
            )}
          </div>
        ) : (
            <div className="wrapper mainWhiteBox">
              <div className="contentBody mainColor">
                <div className="rfConfirmation errorsItems">
                  {store.errors && store.errors.length > 0 ? (
                    store.errors.map((error, index) => (
                      <div key={index} className="error">
                        {error.message}
                      </div>
                    ))
                  ) : (
                      <div className="error">
                        {t('Le service est en maintenance et momentanément interrompu. Veuillez nous excuser pour le désagrément occasionné, nous travaillons à sa remise en ligne dans les plus brefs délais. Nous vous invitons à réessayer ultérieurement.')}
                      </div>
                    )}
                </div>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default HomePage;